/**
 * Волна E (docs/MIGRATION_ROUTER.md §5).
 * Было: <CacheDataRoute exact path='/bar-menu/:barId/:tableId/product/:id' withoutFooter withoutHeader>.
 * path в staticData — для consent-модалки Header (includes('/bar-menu/')).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../../../CacheDataRoute';
import BarMenuProduct from '@routes/BarMenu/stages/BarMenuProduct';

export const Route = createFileRoute('/bar-menu/$barId/$tableId/product/$id')({
  staticData: {
    layout: {
      path: '/bar-menu/:barId/:tableId/product/:id',
      withoutHeader: true,
      withoutFooter: true
    }
  },
  component: () => (
    <CacheDataRoute component={BarMenuProduct} path='/bar-menu/:barId/:tableId/product/:id' />
  )
});
